//imports
import {
    DEVICES_OVERVIEW_GET_DATA_REQUEST,
    DEVICES_OVERVIEW_GET_DATA_RESULT,
    DEVICES_OVERVIEW_REFRESH_FIRMWARES,
    DEVICES_OVERVIEW_REFRESH_FIRMWARES_RESULT,
    DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST,
    DEVICES_OVERVIEW_GET_CTC_INFO_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    device: null,
    error: null,
    refreshResult: null,
    ctcInfo: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DEVICES_OVERVIEW_GET_DATA_REQUEST:
            return { ...state, loading: true };

        case DEVICES_OVERVIEW_GET_DATA_RESULT:
            return { ...state, loading: false, device: action.payload.data, error: action.payload.error };

        case DEVICES_OVERVIEW_REFRESH_FIRMWARES:
            return { ...state, loading: true };

        case DEVICES_OVERVIEW_REFRESH_FIRMWARES_RESULT:
            return { ...state, loading: false, refreshResult: action.payload };
        case DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST:
            return { ...state, loading: true };
        case DEVICES_OVERVIEW_GET_CTC_INFO_RESULT:
            return { ...state, loading: false, ctcInfo: action.payload };
        case CLEAR_REDUX:
            return ["", "DEVICE_OVERVIEW"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
